/* eslint-disable @next/next/no-html-link-for-pages */

/* eslint-disable react/no-unknown-property */

/* eslint-disable @next/next/no-img-element */
import { useEffect, useMemo, useState } from "react";
import { FaRegFilePdf } from "react-icons/fa";
import {
  HiCheck,
  HiOutlineChevronRight,
  HiOutlineChevronDown,
} from "react-icons/hi";
import { HiPlay } from "react-icons/hi2";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { getYoutubeMetaData } from "@/services/productListingAPI/client";
import PropTypes from "prop-types";
import SocialComponent from "@/components/SocialComponent";
import BackToTop from "@/components/backToTop";
import Loader from "@/components/loader";
import ImageZoomModal from "@/components/detailsComponent/ImageZoomModal";
import DownloadIconLink from "@/components/detailsComponent/downloadIconLink";
import LinkWithLabel from "./LinkWithLabel";
import {
  imageFormatter,
  magnify,
  PRODUCT_RESOURCE_TYPE_SPEC_DOC,
  PRODUCT_GIF_LINE_ART_IMAGE,
  PRODUCT_CAROUSEL_IMAGE,
  PRODUCT_PLAN_3D,
  PRODUCT_PLAN_NAME_3D,
  PRODUCT_FRONT_NAME_2D,
  PRODUCT_PLAN_NAME_2D,
  PRODUCT_SIDE_NAME_2D,
  PRODUCT_Front_View_2D,
  PRODUCT_Plan_View_2D,
  PRODUCT_Side_View_2D,
  PRODUCT_ADDITIONAL_IMAGE,
  PDP_LABELS,
  PRODUCT_Cut_Out_DXF,
  PRODUCT_BIMRevit,
  TECHNICAL_INFORMATION_FILES,
  TECHNICAL_INFORMATION_FILES_NAMES,
  DEFAULT_IMAGE_LINK,
  carouselImageFormatter,
  PRODUCT_RESOURCE_TYPE_VIDEO,
  thumbsImageFormatter,
  pdpImagesHandler,
  getColorSwatches,
  getFilteredMarketList,
} from "@/components/detailsComponent/helper";
import VideoModal from "./videoModal";
import { getRequiredSpecification } from "@/utils/helper";
import NotFoundSection from "./NotFound";
import { NumericFormat } from "react-number-format";
import { PLPModalImageFormatter } from "../ProductListing/helper";
import { ExpandIcon } from "@/components/svgs";
import MobileImageZoom from "./MobileImageZoom";
import { getCompareMappings, mapCompareValues } from "@/utils/compareMappings";
import styles from "./index.module.scss";
import { DownloadView } from "@/components/detailsComponent/downloadview";

const productDetailLayoutShift = {
  position: "absolute",
  paddingLeft: "30px",
  right: "0",
  top: "755px",
};

const locale = "en";

const Breadcrumb = ({ breadCrumbsData = [], backLabel = "Back" }) => {
  return (
    <div
      className={`${styles.breadCrumb} px-6 py-[48px] max-[768px]:py-[18px]`}
    >
      <nav className="text-[12px] text-[#666] cursor-pointer">
        <button
          onClick={() => window?.history?.back()}
          className="!text-[#666] !font-[helveticaRoman] font-[800] text-[12px] leading-[12px] bg-transparent border-none cursor-pointer p-0"
        >
          {backLabel}
        </button>
        <span className="mx-2">{"|"}</span>
        {breadCrumbsData.map((item, index) => (
          <>
            <span key={index}>
              {item.href ? (
                <Link
                  href={item.href}
                  className="!text-[#666] !font-[helveticaRoman]"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-[#666] !font-[helveticaRoman]">
                  {item.label}
                </span>
              )}
            </span>
            {index < breadCrumbsData.length - 1 && (
              <span className="mx-2">{index === 0 && ">"}</span>
            )}
          </>
        ))}
      </nav>
    </div>
  );
};

const DetailsComponent = ({
  productDetailsData = {},
  skuInfo = "",
  compareMappingsData = {},
  marketConfiguration = [],
}) => {
  // Destructure only valid JS identifiers, access others via bracket notation
  const {
    ProductWebFeatures_ss: productWebFeatures = [],
    ProductWebMaterial_ss: productWebMaterial = [],
    ProductNarrativeDescription_s: productNarrativeDescription = "",
    sku_s,
    RegionBrandName_ss: regionBrandName = [],
    ProductSection_ss: productSection = [],
    ProductCategory_s: localCategory = "",
    slug_s: slug = "",
    ProductNewProduct = false,
    ProductProductLinkType = [],
    "productImage.url_ss": onlyImage = [
      "https://kohler.scene7.com/is/image/PAWEB/Category_Template?$PDPcon$&$gradient_src=PAWEB%2Forganic-gradient&$shadow_src=PAWEB%2FBlank&$Badge1_src=PAWEB%2FBlank&$Badge4_src=PAWEB%2FBlank&$Badge3_src=PAWEB%2FBlank&$Badge2_src=PAWEB%2FBlank&$product_src=is%7BPAWEB%2Fdefault%7D",
    ],
    ProductItem = [], // temp
    ProductResource = [], //temp(to be removed after data mapping)
    "Color.SKU.Details_ss": colorSkuDetails = [],
    ProductDescriptionProductShort_s: productDescriptionProductShort,
    "ProductResource.DWGFrontView.resourceFullWebURL_ss": dwgFrontView = [],
    "ProductResource.DXFFrontView.resourceFullWebURL_ss": dxfFrontView = [],
    "ProductResource.DWGPlanView.resourceFullWebURL_ss": dwgPlanView = [],
    "ProductResource.DXFPlanView.resourceFullWebURL_ss": dxfPlanView = [],
    "ProductResource.DXFSideView.resourceFullWebURL_ss": dxfSideView = [],
    "ProductResource.DWGSideView.resourceFullWebURL_ss": dwgSideView = [],
    "ProductResource.3D3DS.resourceFullWebURL_ss": product3D3DS = [],
    "ProductResource.3DDWGSymbol.resourceFullWebURL_ss":
      product3DDWGSymbol = [],
    "ProductResource.3DDXFSymbol.resourceFullWebURL_ss":
      product3DDXFSymbol = [],
    "ProductResource.3DOBJ.resourceFullWebURL_ss": product3DOBJ = [],
    "ProductResource.3DRevit.resourceFullWebURL_ss": product3DRevit = [],
    "ProductResource.3DSketchup.resourceFullWebURL_ss": product3DSketchup = [],
    "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss":
      productInstallationPDF = [],
    "ProductResource.SpecPDFFileName.resourceFullWebURL_ss":
      productSpecPDF = [],
    "ProductResource.PartsPDFFileName.resourceFullWebURL_ss":
      productPartsPDF = [],
    "priceList.GST.finalPrice_d": masterPrice = "",
    ProductInstallationType_ss: installationType = [],
    ProductOverallHeightMm_i: ProductOverallHeightMm = "",
    ProductOverallWidthMm_i: ProductOverallWidthMm = "",
    ProductMaterial_s: ProductMaterial = "",
    ProductWebInstallation_ss: ProductWebInstallation = [],
    ProductWebTechnology_ss: ProductWebTechnology = [],
    "ProductResource.GIFLineArt.resourceAltText_ss": gifLineArtAltText = [],
    "ProductResource.GIFLineArt.resourceFullWebURL_ss": gifLineArt = [],
    productDiscontinued_b: productDiscontinued = false,
    RegionRetailer1IMG_ss: regionRetailer1IMG = [],
    RegionRetailer1URL_ss: buyNowURL = [],
    available_markets: availableMarketsContainingSkus = [],
  } = productDetailsData || {};

  const availableMarketsList = useMemo(() => {
    return getFilteredMarketList(
      availableMarketsContainingSkus,
      sku_s,
      marketConfiguration
    );
  }, [availableMarketsContainingSkus, sku_s, marketConfiguration]);

  const color = getRequiredSpecification(colorSkuDetails, sku_s, 2, 0);

  const images = pdpImagesHandler(productDetailsData);

  const swatchImages = getColorSwatches(productDetailsData);

  const swatchFileName = getRequiredSpecification(colorSkuDetails, sku_s, 2, 1);

  const frontView2D = [
    {
      ResourceType: "DWGFrontView",
      ResourceFullWebURL: dwgFrontView?.[0] || "",
    },
    {
      ResourceType: "DXFFrontView",
      ResourceFullWebURL: dxfFrontView?.[0] || "",
    },
  ];

  const sideView2D = [
    {
      ResourceType: "DWGSideView",
      ResourceFullWebURL: dwgSideView?.[0] || "",
    },
    {
      ResourceType: "DXFSideView",
      ResourceFullWebURL: dxfSideView?.[0] || "",
    },
  ];

  const planView2D = [
    {
      ResourceType: "DWGPlanView",
      ResourceFullWebURL: dwgPlanView?.[0] || "",
    },
    {
      ResourceType: "DXFPlanView",
      ResourceFullWebURL: dxfPlanView?.[0] || "",
    },
  ];

  const planView3DObj = [
    {
      ResourceType: "3DRevit",
      ResourceFullWebURL: product3DRevit?.[0] || "",
    },
    {
      ResourceType: "3DSketchup",
      ResourceFullWebURL: product3DSketchup?.[0] || "",
    },
    {
      ResourceType: "3DDXF",
      ResourceFullWebURL: product3DDXFSymbol?.[0] || "",
    },
    {
      ResourceType: "3DDWG",
      ResourceFullWebURL: product3DDWGSymbol?.[0] || "",
    },
    {
      ResourceType: "3D3DS",
      ResourceFullWebURL: product3D3DS?.[0] || "",
    },
    {
      ResourceType: "3DOBJ",
      ResourceFullWebURL: product3DOBJ?.[0] || "",
    },
  ];

  const technicalFilesObj = [
    {
      ResourceType: "SpecPDFFileName",
      ResourceFullWebURL: productSpecPDF?.[0] || "",
    },
    {
      ResourceType: "InstallationWithoutSPPDF",
      ResourceFullWebURL: productInstallationPDF?.[0] || "",
    },
    {
      ResourceType: "PartsPDFFileName",
      ResourceFullWebURL: productPartsPDF?.[0] || "",
    },
    {
      ResourceType: "matchingListPDFFileName",
      ResourceFullWebURL: productSpecPDF?.[0] || "",
    },
  ];

  const router = useRouter();
  const [colorName, setColorName] = useState(color);
  const [carousel, setCarousel] = useState([]);
  const [skuNumber, setSKUNumber] = useState(sku_s);
  const [showColorName, setShowColorName] = useState("");
  const [colorFileName, setColorFileName] = useState(swatchFileName);
  const [specPdfFile, setSpecPdfFile] = useState("");
  const [lineArt, setLineArt] = useState("");
  const [planView3D, setPlanView3D] = useState(planView3DObj);
  const [front2D, setFront2D] = useState(frontView2D);
  const [plan2D, setPlan2D] = useState(planView2D);
  const [side2D, setSide2D] = useState(sideView2D);
  const [cutOutDXF, setCutOutDXF] = useState([]);
  const [bimRevit, setBimRevit] = useState([]);
  const [similarProducts, setSimilarProducts] = useState([]);
  const [zoomActive, setZoomActive] = useState(true);
  const [showZoom, setShowZoom] = useState(false);
  const [technicalInfoFiles, setTechnicalInfoFiles] =
    useState(technicalFilesObj);
  const [colorFinishCodeArray, setColorFinishCodeArray] =
    useState(swatchImages);
  const [imageIndex, setImageIndex] = useState(0);
  const [thumbsPosition, setThumbsPosition] = useState(0);
  const [hasLinkedprodcts, setHasLinkedprodcts] = useState(false);
  const [youTubeLink, setYouTubeLink] = useState([]);
  const [youtubeMetaData, setYoutubeMetaData] = useState([]);
  const [youtubeLinkOpen, setYoutubeLinkOpen] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [availableAt, setAvailableAt] = useState({});
  const [discontinuedBanner, setDiscontinuedBanner] = useState(false);
  const [finalPrice, setFinalPrice] = useState(masterPrice);
  const [isZoomed, setIsZoomed] = useState(false);
  const [marketList, setMarketList] = useState(availableMarketsList);

  const getCircularThumbs = () => {
    if (!carousel || carousel.length <= 3) return carousel;
    const len = carousel.length;
    return [
      carousel[thumbsPosition % len],
      carousel[(thumbsPosition + 1) % len],
      carousel[(thumbsPosition + 2) % len],
    ];
  };

  const visibleThumbs = getCircularThumbs();

  const handlePrevClick = () => {
    if (!carousel || carousel.length === 0) return;

    const nextIndex = imageIndex === carousel.length - 1 ? 0 : imageIndex + 1;
    const nextThumbs = (thumbsPosition + 1) % carousel.length;

    setImageIndex(nextIndex);
    setThumbsPosition(nextThumbs);
  };

  const skuId = router?.query?.skuid?.replace("K-", "");

  const setColorImageFeature = (e, item) => {
    setColorName(item.styleName);
    setSKUNumber(item.skuid);
    setColorFileName(item.styleName);
    setImageIndex(0);
    setThumbsPosition(0);
    setFinalPrice(item.price);

    const matchedImages = images?.filter(img => item.skuid === img.sku) || [];
    setCarousel(matchedImages);

    const availableMarketListSkuBased = getFilteredMarketList(
      availableMarketsContainingSkus,
      item.skuid,
      marketConfiguration
    );
    setMarketList(availableMarketListSkuBased);
  };

  useEffect(() => {
    setIsLoading(true);
    const color_finish_code_array = ProductItem.filter(
      el =>
        el.SKUColorFinishCode !== undefined &&
        el?.links?.ItemResource !== undefined
    );

    const defaultItems = ProductItem?.find(el => el.SKUSKUNo === skuId) || {};
    const carousel_image_array =
      defaultItems?.links?.ItemResource?.filter(
        el => el.ResourceType === PRODUCT_CAROUSEL_IMAGE
      ) || [];

    let other_images = [];

    const youtube_link =
      ProductResource?.filter(item =>
        PRODUCT_RESOURCE_TYPE_VIDEO.includes(item?.ResourceType)
      ) || "";
    setYouTubeLink(youtube_link);

    setCarousel([...images, ...youtube_link]);

    const spec_pdf_link = ProductResource?.find(
      el1 => el1.ResourceType === PRODUCT_RESOURCE_TYPE_SPEC_DOC
    );
    setSpecPdfFile(spec_pdf_link?.ResourceFullWebURL);
    const gif_line_art = ProductResource?.find(
      el1 => el1.ResourceType === PRODUCT_GIF_LINE_ART_IMAGE
    );
    setLineArt(gif_line_art);

    const region_retailer_url = defaultItems?.links?.ItemRegion.find(
      el => el.RegionRetailer1URL != undefined
    );
    setAvailableAt(region_retailer_url);

    // discontinued product
    const discontinued_banner = defaultItems?.SKUDiscontinuedDate !== undefined;
    setDiscontinuedBanner(discontinued_banner);

    const cut_out_dxf = ProductResource?.find(
      el => el.ResourceType === PRODUCT_Cut_Out_DXF
    );
    setCutOutDXF(cut_out_dxf);
    const bim_revit = ProductResource?.find(
      el => el.ResourceType === PRODUCT_BIMRevit
    );
    setBimRevit(bim_revit);
    const has_linked_products = ProductProductLinkType?.find(
      ele => ele.ProductATGISACTIVE === true
    );
    setHasLinkedprodcts(has_linked_products);
    setIsLoading(false);

    // Set initial state based on skuInfo
    if (skuInfo) {
      const initialItem = swatchImages?.find(el => el.skuid === skuInfo);
      if (initialItem) {
        const matchedImages =
          images?.filter(img => initialItem.skuid === img.sku) || [];
        setCarousel(matchedImages);
        setColorName(initialItem.styleName);
        setSKUNumber(initialItem.skuid);
        setColorFileName(initialItem.styleName);
        setImageIndex(0);
        setThumbsPosition(0);
      }
    }
  }, [skuId]);

  useEffect(() => {
    if (carousel.length && imageIndex >= carousel.length) {
      setImageIndex(0);
    }
  }, [carousel, imageIndex]);

  useEffect(() => {
    async function fetchMetaData() {
      let responseArray = await Promise.all(
        youTubeLink?.map(async i => {
          return { i, metaData: await getYoutubeMetaData(i?.ResourceName) };
        })
      );

      setYoutubeMetaData(responseArray);
    }

    fetchMetaData();
  }, [youTubeLink]);

  const removeMagnifierGlass = () => {
    const glasses = document.getElementsByClassName("img-magnifier-glass");
    // Iterate from the end since the collection is live and shrinks as we remove
    for (let i = glasses.length - 1; i >= 0; i--) {
      glasses[i].parentNode?.removeChild(glasses[i]);
    }
  };

  const handleMagnifier = (action, myImageId) => {
    // Always clear any existing lens first to avoid duplicates / stuck lenses
    // caused by stale React state in the previous closure.
    removeMagnifierGlass();
    if (action === "enter") {
      magnify(myImageId, 2);
    }
  };

  const breadCrumbsLocalData =
    localCategory === "Showering" ? "bathroom-showering" : localCategory;

  const breadCrumbsData = [
    {
      label: productSection?.[0],
      href: `/browse/${productSection?.[0]?.toLocaleLowerCase()}`,
    },
    {
      label: localCategory,
      href: `/browse/${productSection?.[0]?.toLocaleLowerCase()}/Categories/${breadCrumbsLocalData?.toLowerCase().replace(/\s+/g, "-")}`,
    },
  ];

  const isEmpty =
    !productDetailsData || Object.keys(productDetailsData)?.length === 0;

  if (isEmpty) {
    return <NotFoundSection />;
  }
  const matchedSkuImageData = images?.find(img => img?.sku === skuNumber);
  const matchedSkuSrc =
    matchedSkuImageData?.fallBackSrc || matchedSkuImageData?.src;
  const matchedSkuImage = matchedSkuSrc ? [matchedSkuSrc] : onlyImage;

  const compareMappings = getCompareMappings(compareMappingsData);
  const pdpCompareSource = {
    originalData: productDetailsData,
    sku: skuNumber,
    skuId: skuNumber,
    slug,
    category: localCategory,
    description: productDescriptionProductShort,
    price: finalPrice && Number(finalPrice) !== 0 ? `IDR ${finalPrice}` : null,
    image: matchedSkuImage,
  };
  const compareMappedValues = mapCompareValues(
    pdpCompareSource,
    compareMappings
  );

  const pdpCompareData = {
    image: matchedSkuImage,
    swatch: colorFinishCodeArray,
    compareMappedValues,
  };

  return (
    <>
      {isLoading && <Loader loading={isLoading} />}
      {discontinuedBanner && (
        <div className="flex h-[30px] items-center justify-center py-5 bg-[#FF0000] drop-shadow-lg text-[#fff] font-semibold">
          {PDP_LABELS[locale].discontinued}
        </div>
      )}
      <section className="max-w-screen-lg mx-auto bg-white text-[#232323] mb-[50px] p-2">
        <Breadcrumb
          breadCrumbsData={breadCrumbsData}
          backLabel={PDP_LABELS[locale].breadCrumbBackLabel}
        />
        <div className="w-full relative">
          {/* Product Carousel start */}
          <div
            className={`flex flex-col float-left w-full md:mb-[30px] ${showZoom ? "md:w-[980px] h-[735px]" : "md:w-2/3"}`}
          >
            {/* carousel */}
            <div className="flex lg:px-4 lg:pb-4 p-0 flex-col-reverse lg:flex-row relative h-full">
              {/* Custom image thumbs */}
              <div
                className={`${styles.customImageThumbs} flex lg:flex-col flex-row lg:w-1/6 items-center lg:absolute w-full lg:w-[105px] lg:top-0 lg:-left-[110px] text-center pl-[10px] lg:pl-0 max-[768px]:max-h-20 max-[768px]:mt-[20px] max-[768px]:mb-[10px] max-[768px]:justify-center`}
              >
                {visibleThumbs &&
                  visibleThumbs.length > 0 &&
                  visibleThumbs.map((imgs, id) => {
                    const itemIndex = (thumbsPosition + id) % carousel.length;
                    return (
                      <div
                        key={
                          typeof imgs === "string"
                            ? imgs
                            : imgs?.ResourceName || itemIndex
                        }
                        className={`w-[105px] ${
                          imageIndex === itemIndex
                            ? "border-3 border-[#7a7a7a]"
                            : ""
                        } m-1`}
                      >
                        <Image
                          src={imgs?.src}
                          height={77}
                          className="w-[105px]"
                          width={105}
                          id={
                            typeof imgs === "string" ? imgs : imgs.ResourceName
                          }
                          alt={imgs?.alt}
                          onError={e =>
                            (e.target.src =
                              imgs?.fallBackSrc || DEFAULT_IMAGE_LINK)
                          }
                          onClick={() => {
                            setImageIndex(itemIndex);
                          }}
                        />
                      </div>
                    );
                  })}
                {carousel?.length > 3 && (
                  <>
                    <button
                      className="lg:hidden block text-[#e5e5e5] hover:text-[#232323]"
                      onClick={() => handlePrevClick()}
                    >
                      <HiOutlineChevronRight size={35} />
                    </button>
                    <button
                      className="lg:block hidden text-[#e5e5e5] hover:text-[#232323]"
                      aria-label="show more images"
                      onClick={() => handlePrevClick()}
                    >
                      <HiOutlineChevronDown size={45} />
                    </button>
                  </>
                )}
              </div>
              {!showZoom ? (
                <div className="flex-1 sm:w-[95%] w-full sm:p-1 relative">
                  <div className="sm:flex hidden">
                    {PRODUCT_RESOURCE_TYPE_VIDEO.includes(
                      carousel[imageIndex]?.ResourceType
                    ) ? (
                      <iframe
                        height="470"
                        width="100%"
                        src={`https://www.youtube.com/embed/${carousel[imageIndex]?.ResourceName}?rel=0`}
                        title="YouTube video player"
                        sandbox="allow-scripts allow-presentation"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen="allowFullScreen"
                        mozallowfullscreen="mozallowfullscreen"
                        msallowfullscreen="msallowfullscreen"
                        oallowfullscreen="oallowfullscreen"
                        webkitallowfullscreen="webkitallowfullscreen"
                        loading="lazy"
                      ></iframe>
                    ) : (
                      <div
                        className="img-magnifier-container"
                        onMouseEnter={e => {
                          setZoomActive(true);
                          handleMagnifier("enter", "myImage");
                        }}
                        onMouseLeave={e => {
                          setZoomActive(false);
                          handleMagnifier("leave", "myImage");
                        }}
                      >
                        <img
                          src={PLPModalImageFormatter(
                            carousel[imageIndex]?.src
                          )}
                          alt={
                            typeof carousel[imageIndex] === "string"
                              ? carousel[imageIndex]?.alt
                              : carousel[imageIndex]?.ResourceName
                          }
                          id="myImage"
                          className="w-full"
                          // width={525}
                          // height={395}
                          onError={e =>
                            (e.target.src =
                              carousel[imageIndex]?.fallBackSrc ||
                              DEFAULT_IMAGE_LINK)
                          }
                        />
                        {productDiscontinued ? (
                          <h2 className="absolute text-center w-full h-auto top-1/2 -translate-y-1/2 px-5 text-6xl  font-['Helvetica-Light',_Helvetica,_sans-serif]">
                            Discontinued
                          </h2>
                        ) : null}
                      </div>
                    )}
                  </div>
                  <div className="sm:hidden flex" id="mobileView">
                    <Carousel
                      dynamicHeight={true}
                      infiniteLoop={false}
                      showStatus={false}
                      showIndicators={false}
                      emulateTouch={!isZoomed}
                      showThumbs={false}
                      showArrows={false}
                      selectedItem={imageIndex}
                      onChange={arg => setImageIndex(arg)}
                    >
                      {carousel && carousel.length > 0 ? (
                        carousel?.map((element, id) => (
                          <>
                            {!PRODUCT_RESOURCE_TYPE_VIDEO.includes(
                              element?.ResourceType
                            ) ? (
                              <div
                                onWheel={e => {
                                  if (window.innerWidth <= 768) {
                                    e.stopPropagation(); // ✅ STOP carousel scroll
                                  }
                                }}
                              >
                                <MobileImageZoom
                                  src={PLPModalImageFormatter(element?.src)}
                                  alt={element?.ResourceName}
                                  fallback={DEFAULT_IMAGE_LINK}
                                  setIsZoomed={setIsZoomed} // ✅ IMPORTANT
                                />
                              </div>
                            ) : (
                              <iframe
                                height="250"
                                width="100%"
                                src={`https://www.youtube.com/embed/${element?.ResourceName}?rel=0`}
                                title="YouTube video player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen="allowFullScreen"
                                mozallowfullscreen="mozallowfullscreen"
                                msallowfullscreen="msallowfullscreen"
                                oallowfullscreen="oallowfullscreen"
                                webkitallowfullscreen="webkitallowfullscreen"
                              ></iframe>
                            )}
                          </>
                        ))
                      ) : (
                        <div>
                          <img
                            src={imageFormatter()}
                            id={"image1"}
                            alt="image1"
                          />
                        </div>
                      )}
                    </Carousel>
                  </div>
                  <button
                    className="md:flex cursor-pointer hidden items-end bg-transparent absolute right-[20px] bottom-[20px] z-20"
                    onClick={() => setShowZoom(true)}
                    aria-label="Image Magnifier"
                  >
                    <ExpandIcon color="#666" />
                  </button>
                </div>
              ) : (
                <ImageZoomModal
                  showImageZoom={setShowZoom}
                  activeIndex={imageIndex}
                  carouselItem={carousel}
                  defaultImageLink={DEFAULT_IMAGE_LINK}
                  isNewProduct={ProductNewProduct}
                />
              )}
            </div>
            {/* Carousel end */}
          </div>
          {/* Product carousel end */}
          <div
            className={`${styles.rightsidePrintContainer} flex flex-col float-right md:w-1/3 w-full lg:px-[15px]`}
            style={showZoom ? productDetailLayoutShift : {}}
          >
            {regionBrandName[0] && (
              <div className="text-[22px] font-['Helvetica-Light',_Helvetica,_sans-serif] font-semibold">
                {regionBrandName[0]}
              </div>
            )}
            <div className="mt-[10px] text-[18px] font-[200] leading-[1.428571429] not-italic font-['Helvetica-Light',_Helvetica,_sans-serif] font-normal mb-[20px]">
              {productDescriptionProductShort}
            </div>
            {skuNumber && (
              <div
                className={`${styles.productSku} font-['Helvetica-Light',_Helvetica,_sans-serif] text-[16px] leading-tight font-normal text-[#666]`}
              >
                K-{skuNumber}
              </div>
            )}
            <div className={`${styles.productColorName} mt-[20px] mb-[10px]`}>
              <span className="pt-[5px] pb-[5px] pr-[5px] font-['helveticaBold',_Helvetica,_sans-serif] text-[15px] leading-tight text-[#000] uppercase">
                {PDP_LABELS[locale].colorName}
              </span>
              {colorName && (
                <span className="ml-[10px] font-['Helvetica-Light',_Helvetica,_sans-serif] text-[14px] leading-tight font-light">
                  {colorName}
                </span>
              )}
            </div>
            <div className={`${styles.productColorSwatch} flex flex-wrap`}>
              {colorFinishCodeArray?.map((el, index) => (
                <div
                  key={index}
                  className="mx-1 relative inline-block pb-2 cursor-pointer"
                  title={el?.styleName || ""}
                  onClick={e => setColorImageFeature(e, el)}
                  onMouseOver={e => {
                    e.preventDefault();
                    setShowColorName(el);
                  }}
                  onMouseOut={e => {
                    e.preventDefault();
                    setShowColorName("");
                  }}
                >
                  <Image
                    src={el?.src}
                    alt={el?.SKUColorSwatchFilename}
                    width={40}
                    height={40}
                    onError={e => (e.target.src = DEFAULT_IMAGE_LINK)}
                  />
                  {colorFileName === el.styleName && (
                    <div className="absolute top-0 right-0 h-[40px] w-[40px] bg-cover border-2 border-neutral-500">
                      <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-[#fff]">
                        <HiCheck size={30} />
                      </div>
                    </div>
                  )}
                  {showColorName && showColorName === el.SKUColorFinishName && (
                    <span className="absolute top-full p-[10px] bg-[#f9f9f9] border-1 border-neutral-500 rounded-md shadow font-helvetica leading-tight text-[13px] w-max z-10 hidden md:block">
                      {colorFinishCodeArray.styleName}
                    </span>
                  )}
                </div>
              ))}
            </div>
            <div className="hidden print:block mt-[20px] mb-[20px] w-[50%]">
              {productNarrativeDescription ? (
                <div className="font-['Helvetica-Light',_Helvetica,_sans-serif] text-[15px] text-[#232323] mb-[40px] lg:mt-0 text-left">
                  {productNarrativeDescription}
                </div>
              ) : null}
            </div>
            {marketList?.length ? (
              <div className="mt-[10px] py-[15px] clear-both">
                <div className="font-['helveticaBold',_Helvetica,_sans-serif] text-2xl font-normal leading-none text-black uppercase">
                  Available In
                </div>
                {marketList.map(country => {
                  const {
                    productDetailSlug = "",
                    productDetailParameter = "",
                    url = "",
                    isEnableLink = "",
                    label = "",
                  } = country || {};
                  return (
                    <div
                      className="font-['Helvetica-Light',_Helvetica,_sans-serif] font-normal leading-none mt-[10px] text-[13px]"
                      key={label}
                    >
                      {isEnableLink ? (
                        <Link
                          href={
                            url
                              ? `${url}/${productDetailSlug}/${slug}?${productDetailParameter}=${skuNumber}`
                              : "#"
                          }
                          target="_blank"
                          className="cursor-pointer no-underline text-[#337ab7] hover:!no-underline"
                        >
                          {label} {skuNumber && `(K-${skuNumber})`}
                        </Link>
                      ) : (
                        <span>
                          {label} {skuNumber && `(K-${skuNumber})`}
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : null}
            {!discontinuedBanner && (
              <>
                <div
                  className={`${styles.storeLocatorButton} mt-3 rounded-sm bg-[#364573] hover:bg-[#1f2b54] text-center hover:cursor-pointer`}
                >
                  <Link href={`/storelocator`} passHref legacyBehavior>
                    <a
                      href={`/storelocator`}
                      target="_self"
                      className="pt-[14px] pb-[13px] w-full m-0 outline-none inline-block px-5 rounded text-center no-underline font-[HelveticaBold, Helvetica, sans-serif] text-[13px] leading-[13px] !text-white uppercase border-0 font-[900] hover:!no-underline"
                    >
                      {PDP_LABELS[locale].findAStoreLabel}
                    </a>
                  </Link>
                </div>
                <div
                  className={`${styles.enquiryButton} hover:cursor-pointer mt-3 rounded-sm bg-[#364573] hover:bg-[#1f2b54] text-center`}
                >
                  <Link href="/contact-form" passHref legacyBehavior>
                    <a
                      href="/contact-form"
                      target="_self"
                      className="pt-[14px] pb-[13px] hover:!no-underline w-full m-0 outline-none inline-block px-5 rounded text-center no-underline font-[HelveticaBold, Helvetica, sans-serif] text-[13px] leading-[13px] !text-white uppercase border-0 font-[900]"
                    >
                      {PDP_LABELS[locale].enquiryLabel}
                    </a>
                  </Link>
                </div>
              </>
            )}
            {regionRetailer1IMG?.length ? (
              <div className="mb-5 clear-both">
                <span className="font-[HelveticaRoman, Helvetica, sans-serif] font-normal !not-italic text-[14px] block my-5 mx-auto">
                  {PDP_LABELS[locale].featureRetailers}
                </span>
                <div className="border-b border-[#ccc] py-[25px] px-0 first-of-type:border-t">
                  <div className="flex justify-between items-center">
                    <div className="max-w-[80px]">
                      <img
                        src="https://kohler.scene7.com/is/image/PAWEB/WTBLogo_Ritavo?$WTB_featured_retailer$"
                        className="retail-logo display-none-md-only"
                      />
                    </div>
                    <a
                      href={buyNowURL?.[0] || "#"}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div
                        id="product-detail__retail-buy-now"
                        className="font-[HelveticaBold,Helvetica,sans-serif] w-[153px] h-10 leading-10 bg-[#84a648] shadow-none px-5 uppercase inline-block cursor-pointer !not-italic text-center rounded border-none text-[14px] text-white"
                      >
                        {PDP_LABELS[locale].buyNow}
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            ) : null}
            <SocialComponent pageType={"pdp"} pdpCompareData={pdpCompareData} />
            {availableAt && Object.keys(availableAt).length > 0 && (
              <div className="flex flex-col mt-6 ">
                <div className="text-[16px] font-['Helvetica-Light',_Helvetica,_sans-serif]">
                  {PDP_LABELS[locale].availableAt}
                </div>
                <div className="flex">
                  <Link
                    href={availableAt.RegionRetailer1URL.trim()}
                    passHref
                    legacyBehavior
                  >
                    <a target="_blank" rel="noopener noreferrer">
                      <img
                        src={`https://kohler.scene7.com/is/image/PAWEB/${availableAt.RegionRetailer1IMG}?$WTB_featured_retailer$`}
                        alt={PDP_LABELS[locale].availableAt}
                      />
                    </a>
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="w-full lg:mx-2 lg:mb-2 lg:mt-[40px] m-0 pt-[40px]">
          <div className="md:w-2/3 w-full ">
            {productDiscontinued ? (
              <div>
                <span className="block mb-1 font-['Helvetica-Light',_Helvetica,_sans-serif] text-[16px] leading-none font-normal text-[#e50000]">
                  This product has been discontinued.
                </span>
              </div>
            ) : productNarrativeDescription ? (
              <div
                className={`${styles.productNarrativeDescription} font-['Helvetica-Light',_Helvetica,_sans-serif] text-[15px] text-[#232323] mb-[40px] lg:mt-0 text-left`}
              >
                {productNarrativeDescription}
              </div>
            ) : null}
            {productSpecPDF.length > 0 && (
              <div
                className={`${styles.productSpecPDF} mb-[40px] cursor-pointer`}
              >
                <LinkWithLabel
                  className="inline-flex text-[14px]"
                  label={PDP_LABELS[locale].specFileLabel}
                  url={productSpecPDF[0]}
                  icon={<FaRegFilePdf color="red" size={15} />}
                />
              </div>
            )}
            {productWebFeatures && productWebFeatures.length > 0 && (
              <>
                <hr className="border-[#e8e8e8]" />
                <div className="mt-[20px] mb-[10px] font-['Helvetica-Light',_Helvetica,_sans-serif] text-[20px] uppercase leading-tight font-light">
                  {PDP_LABELS[locale].characteristics}
                </div>
                <ul className="list-disc px-[18px]">
                  {productWebFeatures.map(
                    (feature, index) =>
                      feature && (
                        <li
                          key={index}
                          className="mb-[15px] text-[15px] font-['Helvetica-Light',_Helvetica,_sans-serif]"
                        >
                          {" "}
                          {feature}
                        </li>
                      )
                  )}
                </ul>
              </>
            )}
            {ProductWebTechnology && ProductWebTechnology.length > 0 && (
              <>
                <div className="mt-[10px] mb-[10px] font-['Helvetica-Medium',_Helvetica,_sans-serif] text-[15px] font-[400]">
                  {PDP_LABELS[locale].technology}
                </div>
                <ul className="list-disc px-[18px]">
                  {ProductWebTechnology.map(
                    (technology, index) =>
                      technology && (
                        <li
                          key={index}
                          className="mb-[15px] text-[15px] font-['Helvetica-Light',_Helvetica,_sans-serif]"
                        >
                          {" "}
                          {technology}
                        </li>
                      )
                  )}
                </ul>
              </>
            )}
            {ProductWebInstallation && ProductWebInstallation.length > 0 && (
              <>
                <div className="mt-[10px] mb-[10px] font-['Helvetica-Medium',_Helvetica,_sans-serif] text-[15px] font-[400]">
                  {PDP_LABELS[locale].installation}
                </div>
                <ul className="list-disc px-[18px]">
                  {ProductWebInstallation.map(
                    (installation, index) =>
                      installation && (
                        <li
                          key={index}
                          className="mb-[15px] text-[15px] font-['Helvetica-Light',_Helvetica,_sans-serif]"
                        >
                          {" "}
                          {installation}
                        </li>
                      )
                  )}
                </ul>
              </>
            )}
            {productWebMaterial && productWebMaterial.length > 0 && (
              <>
                <div className="mt-[10px] mb-[10px] font-['Helvetica-Medium',_Helvetica,_sans-serif] text-[15px] font-[400]">
                  {PDP_LABELS[locale].material}
                </div>
                <ul className="list-disc px-[18px]">
                  {productWebMaterial.map(
                    (material, index) =>
                      material && (
                        <li
                          key={index}
                          className="mb-[15px] text-[15px] font-['Helvetica-Light',_Helvetica,_sans-serif]"
                        >
                          {" "}
                          {material}
                        </li>
                      )
                  )}
                </ul>
              </>
            )}
            <div className="mb-[20px] pl-[10px] print:hidden">
              {[...front2D, ...side2D, ...plan2D, ...planView3D].some(
                el => el.ResourceFullWebURL
              ) && (
                <>
                  {[...plan2D, ...front2D, ...side2D, ...planView3D].some(
                    el => el.ResourceFullWebURL
                  ) && (
                    <>
                      <hr className="border-[#e8e8e8]" />
                      <div className="mt-[24px] mb-[40px] font-['Helvetica-Light',_Helvetica,_sans-serif] uppercase text-[30px] leading-tight font-light">
                        {PDP_LABELS[locale].resources}
                      </div>
                      <div className="pb-[20px] font-['Helvetica-Light',_Helvetica,_sans-serif] text-[20px] uppercase leading-tight font-light">
                        {PDP_LABELS[locale].cadTemplate}
                      </div>
                    </>
                  )}
                  <div className="flex flex-col">
                    {cutOutDXF && cutOutDXF.ResourceFullWebURL && (
                      <>
                        <p className="font-helveticaGroup font-semibold text-[14px]">
                          {PDP_LABELS[locale].cutOutTemplates}
                        </p>
                        <ul className="inline-flex flex-wrap mb-2">
                          <DownloadIconLink
                            url={cutOutDXF?.ResourceFullWebURL}
                            size={20}
                          />
                          <li>
                            <LinkWithLabel
                              url={cutOutDXF.ResourceFullWebURL}
                              label={"DXF"}
                              className="font-helveticaGroup font-light text-[14px] uppercase"
                            />
                          </li>
                        </ul>
                      </>
                    )}
                  </div>
                  <div className="flex flex-col">
                    {bimRevit && bimRevit.ResourceFullWebURL && (
                      <ul className="inline-flex flex-wrap mb-2">
                        <DownloadIconLink
                          url={bimRevit?.ResourceFullWebURL}
                          size={20}
                        />
                        <li>
                          <LinkWithLabel
                            url={bimRevit.ResourceFullWebURL}
                            label={PDP_LABELS[locale].bimRevit}
                            className="font-helveticaGroup font-light text-[14px] uppercase"
                          />
                        </li>
                      </ul>
                    )}
                  </div>
                  <div className="flex md:justify-between md:flex-row flex-col">
                    <div className="flex">
                      <div className="flex flex-col">
                        {(plan2D.some(el => el.ResourceFullWebURL) ||
                          front2D.some(el => el.ResourceFullWebURL) ||
                          side2D.some(el => el.ResourceFullWebURL)) && (
                          <>
                            {plan2D.some(el => el.ResourceFullWebURL) && (
                              <p className="font-[helveticaBold,_Helvetica,_sans-serif] text-[14px]">
                                {PDP_LABELS[locale].cadFiles2D}
                              </p>
                            )}
                            {plan2D.some(el => el.ResourceFullWebURL) && (
                              <>
                                {plan2D?.length > 0 ? (
                                  <DownloadView
                                    pdpLabelName={PDP_LABELS[locale].plan}
                                    documentList={plan2D}
                                    productName={PRODUCT_PLAN_NAME_2D}
                                  />
                                ) : null}
                              </>
                            )}
                            {front2D.some(el => el.ResourceFullWebURL) && (
                              <>
                                {front2D?.length > 0 ? (
                                  <DownloadView
                                    pdpLabelName={PDP_LABELS[locale].front}
                                    documentList={front2D}
                                    productName={PRODUCT_FRONT_NAME_2D}
                                  />
                                ) : null}
                              </>
                            )}
                            {side2D.some(el => el.ResourceFullWebURL) && (
                              <>
                                {side2D?.length > 0 ? (
                                  <DownloadView
                                    pdpLabelName={PDP_LABELS[locale].side}
                                    documentList={side2D}
                                    productName={PRODUCT_SIDE_NAME_2D}
                                  />
                                ) : null}
                              </>
                            )}

                            {front2D?.[0]?.ResourceFullWebURL && (
                              <>
                                {front2D?.length > 0 ? (
                                  <DownloadView
                                    pdpLabelName={PDP_LABELS[locale].overall}
                                    documentList={[front2D?.[0]]}
                                    productName={PRODUCT_FRONT_NAME_2D}
                                  />
                                ) : null}
                              </>
                            )}
                          </>
                        )}
                        {!plan2D.some(el => el.ResourceFullWebURL) &&
                          !front2D.some(el => el.ResourceFullWebURL) &&
                          !side2D.some(el => el.ResourceFullWebURL) &&
                          planView3D.some(el => el.ResourceFullWebURL) && (
                            <>
                              <p className="font-[helveticaBold,_Helvetica,_sans-serif] text-[14px] mb-[10px]">
                                {PDP_LABELS[locale].cadFiles3D}
                              </p>
                              <ul className="inline-flex flex-wrap mb-[10px]">
                                {planView3D?.map((el, id) => (
                                  <>
                                    <DownloadIconLink
                                      url={el?.ResourceFullWebURL}
                                    />
                                    <li key={el?.ResourceName || id}>
                                      <LinkWithLabel
                                        url={el?.ResourceFullWebURL}
                                        label={
                                          PRODUCT_PLAN_NAME_3D[el?.ResourceType]
                                        }
                                        className={`font-helveticaGroup font-light text-[14px] pr-2 uppercase ${
                                          el?.ResourceFullWebURL &&
                                          planView3D
                                            .slice(id + 1)
                                            .some(e => e?.ResourceFullWebURL)
                                            ? `border-r border-black`
                                            : ""
                                        }`}
                                      />
                                    </li>
                                  </>
                                ))}
                              </ul>
                            </>
                          )}
                      </div>
                    </div>
                    {(plan2D.some(el => el?.ResourceFullWebURL) ||
                      front2D.some(el => el?.ResourceFullWebURL) ||
                      side2D.some(el => el?.ResourceFullWebURL)) && (
                      <div className="flex flex-col mt-[20px] md:mt-0">
                        {planView3D.some(el => el.ResourceFullWebURL) && (
                          <>
                            <p className="font-[helveticaBold,_Helvetica,_sans-serif] text-[14px] mb-[10px]">
                              {PDP_LABELS?.[locale]?.cadFiles3D}
                            </p>
                            <ul className="inline-flex flex-wrap mb-[10px]">
                              {planView3D?.map(
                                (el, id) =>
                                  el?.ResourceFullWebURL && (
                                    <>
                                      {PRODUCT_PLAN_NAME_3D[
                                        el?.ResourceType
                                      ] ? (
                                        <DownloadIconLink
                                          url={el?.ResourceFullWebURL}
                                          size={18}
                                        />
                                      ) : null}
                                      <li key={el?.ResourceName || id}>
                                        <LinkWithLabel
                                          url={el?.ResourceFullWebURL}
                                          label={
                                            PRODUCT_PLAN_NAME_3D[
                                              el?.ResourceType
                                            ]
                                          }
                                          className={`font-helveticaGroup font-light text-[14px] pr-2 uppercase ${
                                            el?.ResourceFullWebURL &&
                                            planView3D
                                              .slice(id + 1)
                                              .some(e => e?.ResourceFullWebURL)
                                              ? `border-r border-black`
                                              : ""
                                          }`}
                                        />
                                      </li>
                                    </>
                                  )
                              )}
                            </ul>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
            <hr className="border-[#e8e8e8]" />
            <div className="flex flex-col">
              {youtubeMetaData && youtubeMetaData.length > 0 && (
                <>
                  <div className="mt-[20px] mb-[10px] font-['Helvetica-Light',_Helvetica,_sans-serif] text-[20px] uppercase leading-tight font-light">
                    Videos
                  </div>
                  <div className="flex flex-wrap lg:flex-nowrap md:flex-row flex-col pb-4">
                    {youtubeMetaData?.map((item, id) => (
                      <>
                        {item?.metaData?.items.length > 0 && (
                          <div
                            key={item?.i?.ResourceName || id}
                            className="pr-4 md:w-1/3 w-full pb-4"
                          >
                            <div className="relative">
                              <Image
                                src={
                                  item?.metaData?.items &&
                                  item?.metaData?.items[0]?.snippet?.thumbnails
                                    ?.standard?.url
                                }
                                onError={e =>
                                  (e.target.src = DEFAULT_IMAGE_LINK)
                                }
                                className="w-full"
                                alt="youtube thumbnail"
                                width={
                                  item?.metaData?.items[0]?.snippet?.thumbnails
                                    ?.standard?.width
                                }
                                height={
                                  item?.metaData?.items[0]?.snippet?.thumbnails
                                    ?.standard?.height
                                }
                                aria-label="youtube thumbnail"
                              />
                              <button
                                className="absolute top-[40%] right-[40%] h-[50px] w-[50px] bg-black opacity-40 border-2 rounded-full border-neutral-500 cursor-pointer"
                                onClick={() => setYoutubeLinkOpen(item)}
                              >
                                <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-[#fff]">
                                  <HiPlay size={30} />
                                </div>
                              </button>
                            </div>
                            <div className="font-['Helvetica-Light',_Helvetica,_sans-serif] text-[14px] font-bold text-[#232323] mb-1 leading-tight">
                              {item?.metaData?.items &&
                                item?.metaData?.items[0]?.snippet?.title}
                            </div>
                            <div className="font-['Helvetica-Light',_Helvetica,_sans-serif] text-[12px] text-[#232323] mb-1 leading-tight truncate h-9">
                              {item?.metaData?.items &&
                                item?.metaData?.items[0]?.snippet?.description}
                            </div>
                            {Object.keys(youtubeLinkOpen).length > 0 && (
                              <VideoModal
                                item={youtubeLinkOpen}
                                setYoutubeLinkOpen={e => setYoutubeLinkOpen(e)}
                              />
                            )}
                          </div>
                        )}
                      </>
                    ))}
                  </div>
                </>
              )}
            </div>
            <hr className="border-[#e8e8e8]" />
            <div>
              <p
                className={`${styles.supportTitle} mt-[30px] uppercase font-['Helvetica-Light',_Helvetica,_sans-serif] text-[20px]`}
              >
                {PDP_LABELS[locale].supportService}
              </p>
            </div>
            <div className={`${styles.supportContent} mt-[20px]`}>
              <p className="mb-[20px] text-[14px]">
                {PDP_LABELS[locale].supportServiceQ}
              </p>
              <div
                className="mb-[20px] text-[14px]"
                dangerouslySetInnerHTML={{
                  __html: PDP_LABELS[locale].supportServiceDesc,
                }}
              />
            </div>
            <hr className="border-[#e8e8e8]" />
            <div className="mt-[20px] mb-[10px] font-['Helvetica-Light',_Helvetica,_sans-serif] text-[20px] uppercase leading-tight font-light">
              {PDP_LABELS[locale].technicalInformation}
            </div>
            <div className="flex flex-col md:flex-row mb-[20px] md:gap-[120px]">
              <div className="flex flex-col w-[50%]">
                {ProductOverallHeightMm ||
                ProductOverallWidthMm ||
                productSpecPDF?.[0] ||
                productInstallationPDF?.[0] ||
                productPartsPDF?.[0] ||
                productSpecPDF?.[0] ? (
                  <>
                    {ProductOverallHeightMm || ProductOverallWidthMm ? (
                      <>
                        <div className="font-[helveticaBold,_Helvetica,_sans-serif] text-[14px] leading-tight font-semibold mb-[10px]">
                          {PDP_LABELS[locale].dimension}:
                        </div>

                        <div className="flex flex-row flex-wrap">
                          {ProductOverallHeightMm ? (
                            <span>
                              <span className="font-[helveticaBold,_Helvetica,_sans-serif] text-[14px] leading-tight font-semibold mr-[5px]">
                                H
                              </span>
                              <span className="text-[14px]">
                                {ProductOverallHeightMm}
                              </span>{" "}
                              mm,{" "}
                            </span>
                          ) : null}
                          {ProductOverallWidthMm ? (
                            <span>
                              <span className="font-[helveticaBold,_Helvetica,_sans-serif] text-[14px] ml-[6px] leading-tight font-semibold mr-[5px]">
                                W
                              </span>
                              <span className="text-[14px]">
                                {ProductOverallWidthMm}
                              </span>{" "}
                              mm{" "}
                            </span>
                          ) : null}
                        </div>
                      </>
                    ) : null}
                  </>
                ) : null}
                {gifLineArt[0] ? (
                  <div className="mt-[30px] relative w-[380px] h-[175px] md:w-[470px] md:h-[216px]">
                    <Image
                      src={gifLineArt[0]}
                      alt={gifLineArtAltText[0] || "Gif line art"}
                      fill
                      sizes="(max-width: 768px) 380px, 470px"
                      style={{
                        objectFit: "contain",
                      }}
                      aria-label="Gif line art"
                    />
                  </div>
                ) : null}
                <div className="mt-[15px] flex-col flex">
                  {technicalInfoFiles?.map((element, id) => (
                    <div
                      className="inline-flex print:hidden"
                      key={element?.ResourceName || id}
                    >
                      {element.ResourceFullWebURL && (
                        <LinkWithLabel
                          icon={<FaRegFilePdf color="red" />}
                          url={element.ResourceFullWebURL}
                          label={
                            TECHNICAL_INFORMATION_FILES_NAMES?.[locale]?.[
                              element.ResourceType
                            ]
                          }
                          className="mb-[10px] inline-flex font-[Helvetica-Light,_Helvetica,_sans-serif] text-[14px] font-light"
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex flex-col ml-[20px] mt-[30px] md:mt-0">
                {regionBrandName.length ? (
                  <>
                    <div className="font-[helveticaBold,_Helvetica,_sans-serif] text-[14px] leading-tight mb-[10px]">
                      {PDP_LABELS[locale].collection}:
                    </div>
                    <div className="mb-[15px]">{regionBrandName[0]}</div>
                  </>
                ) : null}
                {ProductMaterial && (
                  <>
                    <div className="font-[helveticaBold,_Helvetica,_sans-serif] text-[14px] leading-tight mb-[10px]">
                      {PDP_LABELS[locale].material}
                    </div>
                    <div className="mb-[20px]">{ProductMaterial}</div>
                  </>
                )}
                {installationType && installationType.length > 0 && (
                  <>
                    <div className="font-[helveticaBold,_Helvetica,_sans-serif] text-[14px] leading-tight mb-[10px]">
                      {PDP_LABELS[locale].installation}
                    </div>
                    <div>{installationType[0]}</div>
                  </>
                )}
              </div>
            </div>
            <div className="print:hidden font-[HelveticaRoman, Helvetica, sans-serif] text-[10px] font-[600] text-[#232323]">
              <p>{PDP_LABELS[locale].productDisclaimer}</p>
            </div>
          </div>
        </div>
      </section>
      <BackToTop topHeight={0} localeProp={locale} />
    </>
  );
};

DetailsComponent.propTypes = {
  compareMappingsData: PropTypes.object,
  productDetailsData: PropTypes.shape({
    data: PropTypes.shape({
      product: PropTypes.shape({
        links: PropTypes.shape({
          ProductItem: PropTypes.array,
          ProductResource: PropTypes.array,
          ProductProductLinkType: PropTypes.array,
        }),
        productBrandName: PropTypes.string,
        ProductProductNo: PropTypes.string,
        productDescriptionProductShort: PropTypes.string,
        ProductDefaultSKU: PropTypes.string,
        productNarrativeDescription: PropTypes.string,
        ProductWebFeatures01: PropTypes.string,
        ProductWebFeatures02: PropTypes.string,
        ProductWebFeatures03: PropTypes.string,
        ProductWebFeatures04: PropTypes.string,
        ProductWebFeatures05: PropTypes.string,
        ProductWebFeatures06: PropTypes.string,
        ProductWebFeatures07: PropTypes.string,
        ProductWebFeatures08: PropTypes.string,
        ProductWebFeatures09: PropTypes.string,
        ProductWebFeatures10: PropTypes.string,
        ProductWebFeatures11: PropTypes.string,
        ProductWebFeatures12: PropTypes.string,
        ProductWebFeatures13: PropTypes.string,
        ProductWebInstallation01: PropTypes.string,
        ProductWebInstallation02: PropTypes.string,
        ProductWebInstallation03: PropTypes.string,
        ProductWebInstallation04: PropTypes.string,
        ProductWebInstallation05: PropTypes.string,
        ProductWebInstallation06: PropTypes.string,
        ProductWebMaterial01: PropTypes.string,
        ProductWebMaterial02: PropTypes.string,
        ProductWebMaterial03: PropTypes.string,
        ProductWebTechnology01: PropTypes.string,
        ProductWebTechnology02: PropTypes.string,
        ProductWebTechnology03: PropTypes.string,
        ProductOverallLengthMm: PropTypes.number,
        ProductOverallHeightMm: PropTypes.number,
        ProductOverallWidthMm: PropTypes.number,
        ProductMaterial: PropTypes.string,
        ProductInstallationType: PropTypes.string,
        ProductLocalCategory: PropTypes.array,
        ProductSection: PropTypes.array,
        ProductProductType: PropTypes.string,
        ProductMETADESCRIPTION: PropTypes.string,
        ProductNewProduct: PropTypes.bool,
      }),
    }),
  }),
};

export default DetailsComponent;
